import Vue from 'vue';
import store from 'store';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { isTablet, convertGQLToProductJson } from 'utils/general';
import * as gqlQueries from 'lib/graphql/queries';
import storefront from 'lib/storefront';
import { A11y, Keyboard, Navigation } from 'swiper/modules';

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'product-card-slider-swiper': () =>
        import('../product-card-slider-swiper/product-card-slider-swiper.vue'),
    },
    el,
    store,
    name: 'Product Recent',
    data: () => ({
      hasSlider: false,
      isTablet: false,
      loading: false,
      vProducts: [],
      color: '#ff0000',
      size: '48px',
    }),
    async mounted() {
      let rvProductList = window.localStorage.getItem(
        'recentViewedProductList',
      );
      rvProductList = rvProductList ? JSON.parse(rvProductList) : [];
      rvProductList = rvProductList.slice(0, -1);
      this.loading = true;
      rvProductList.forEach(async (prod) => {
        const slug = prod.handle;
        const storefrontResponse = await storefront.request(
          gqlQueries.product,
          { handle: slug },
        );
        if (storefrontResponse.product) {
          const product = convertGQLToProductJson(storefrontResponse.product);
          const updatedVariants = product.variants;

          // Places last viewed variant to the first place
          const index = updatedVariants.findIndex(
            (variant) => variant.id === prod.variant,
          );
          if (index !== -1) {
            const objToMove = updatedVariants[index];
            updatedVariants.splice(index, 1);
            updatedVariants.unshift(objToMove);
            product.variants = updatedVariants;
          }

          product.isRecent = true;
          this.vProducts.push(product);
        }
      });
      this.loading = false;
      this.initSlider();
      this.handleResize();
      on(window, 'resize', debounce(this.handleResize), 100);
    },
    computed: {
      showProgress() {
        return this.isTablet && this.hasSlider;
      },
      swiperOptions() {
        return {
          modules: [A11y, Keyboard, Navigation],
          navigation: {
            nextEl: `#${el.id} .slider-next`,
            prevEl: `#${el.id} .slider-prev`,
          },
          slidesPerView: 'auto',
          loop: this.vProducts.length > 4 ? true : false,
          a11y: true,
          keyboard: true,
          on: {
            resize: function(swiper) {
              const heights = swiper.slides.map((slide) => slide.offsetHeight);
              const maxHeight = Math.max(...heights);
              swiper.slides.forEach(slide => slide.style.height = `${maxHeight}px`);
            }
          },
        }
      }
    },
    methods: {
      initSlider() {
        const hasSlider = this.$el.dataset.slider;
        this.hasSlider = !!hasSlider;
      },
      handleResize() {
        this.isTablet = isTablet();
      },
    },
  });
